import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import Pdf from '../component/pdf';
import HeadPdf from '../component/head-pdf';
import moIndex from '../store';
import Title from '../component/title';
import FootPdf from '../component/foot-pdf';
import './scss/company.scss';
import CompanyChart from './component/company-chart';
import { isEmpty, round } from 'lodash';
import moDemandPdf from './store';
import ComapnyTable from './component/company-table';

interface IProps {}
interface IState {}

const CompanyTime = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { companyIndsutryListTime } = moDemandPdf;

  const getTimeDetail = useMemo(() => {
    let max: any = '';
    let mid: any = '';
    let min: any = '';
    let time: any = '';
    if (!isEmpty(companyIndsutryListTime)) {
      max =
        companyIndsutryListTime[companyIndsutryListTime.length - 1]
          .increase_ratio - companyIndsutryListTime[0].increase_ratio;
      mid =
        companyIndsutryListTime[companyIndsutryListTime.length - 1]
          .unchange_ratio - companyIndsutryListTime[0].unchange_ratio;
      min =
        companyIndsutryListTime[companyIndsutryListTime.length - 1]
          .decrease_ratio - companyIndsutryListTime[0].decrease_ratio;
    }
    time = '近8季';
    return { max, mid, min, time };
  }, [companyIndsutryListTime]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id='company'>
      <Pdf>
        <section className="company-pdf-warp">
          <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
          <section className="company-top-title">
            <Title title="招聘动态 - 按时间" bigTitle="人力需求" />
            <p className="details">
              统计说明：先统计每家样本公司当前周期比较上一期的招聘量变化，招聘量增加的为扩招，招聘
            </p>
            <p className="details">
              量减少的为缩招，招聘量基本不变的为平招；然后统计扩招、平招、缩招的公司占行业公司总数
            </p>
            <p className="details" style={{ marginBottom:'10px' }}>的比例</p>
            <CompanyChart />
            <ComapnyTable />
          </section>
          <FootPdf />
        </section>
      </Pdf>
      <Pdf>
        <section className="company-pdf-warp">
          <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
          <section className="company-top-title">
            <Title title="招聘动态 - 按时间" bigTitle="人力需求" />
            <p className="details">
              统计说明：先统计每家样本公司当前周期比较上一期的招聘量变化，招聘量增加的为扩招，招聘
            </p>
            <p className="details">
              量减少的为缩招，招聘量基本不变的为平招；然后统计扩招、平招、缩招的公司占行业公司总数
            </p>
            <p className="details">的比例</p>
            <section className="say-Details">
              <p>解读：</p>
              <p>
                {getTimeDetail?.time}，扩招公司占比
                {getTimeDetail?.max > 0 &&
                          `上涨「${round(
                            Math.abs(getTimeDetail?.max) * 100,
                            1,
                          )}%」`}
                {getTimeDetail?.max === 0 && '不变'}
                {getTimeDetail?.max < 0 &&
                          `下降「${round(
                            Math.abs(getTimeDetail?.max) * 100,
                            1,
                          )}%」`}
              </p>
              <p>
                {getTimeDetail?.time}，平招公司占比
                {getTimeDetail?.mid > 0 &&
                          `上涨「${round(
                            Math.abs(getTimeDetail?.mid) * 100,
                            1,
                          )}%」`}
                {getTimeDetail?.mid === 0 && '不变'}
                {getTimeDetail?.mid < 0 &&
                          `下降「${round(
                            Math.abs(getTimeDetail?.mid) * 100,
                            1,
                          )}%」`}
              </p>
              <p>
                {getTimeDetail?.time}，缩招公司占比
                {getTimeDetail?.min > 0 &&
                          `上涨「${round(
                            Math.abs(getTimeDetail?.min) * 100,
                            1,
                          )}%」`}
                {getTimeDetail?.min === 0 && '不变'}
                {getTimeDetail?.min < 0 &&
                          `下降「${round(
                            Math.abs(getTimeDetail?.min) * 100,
                            1,
                          )}%」`}
              </p>
            </section>
          </section>
          <FootPdf />
        </section>
      </Pdf>
    </section>
  );
};

export default observer(CompanyTime);
